import InputGroup from './InputGroup'
import HeaderMenuCommon from './HeaderMenuCommon'
import UiClickOutside from './UiClickOutside'
import UiSwiper from './UiSwiper'
import ModalTrigger from './ModalTrigger'
import CardsNavigate from './CardsNavigate'
import UiSwiperIndustries from './UiSwiperIndustries'
import FilterCards from './FilterCards'
import UiLimitPagination from './UiLimitPagination'

export default function Components(Vue) {
  Vue.component('HeaderMenuCommon', HeaderMenuCommon)
  Vue.component('UiSwiper', UiSwiper)
  Vue.component('InputGroup', InputGroup)
  Vue.component('UiClickOutside', UiClickOutside)
  Vue.component('ModalTrigger', ModalTrigger)
  Vue.component('CardsNavigate', CardsNavigate)
  Vue.component('UiSwiperIndustries', UiSwiperIndustries)
  Vue.component('FilterCards', FilterCards)
  Vue.component(UiLimitPagination.name, UiLimitPagination)
}



// WEBPACK FOOTER //
// ./src/js/components/app/UiElements/index.js